import React from 'react';
import styled from 'styled-components/macro';

const Styles = styled.section`
  .time {
    font-family: var(--f-header);
    margin-bottom: var(--s-tiny);
  }
`

const TimeEntry = (props) => {
  return (<Styles {...props} />)
}

export default TimeEntry;
